import React from "react";
import RadialChart from "./RadialChart";
import { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import axios from "axios";

const SocialSource = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;
  const [orderStatusesCount, setOrderStatusesCount] = useState({});

  const fetchOrderStatusesCount = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/orders/get-order-statuses-count`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.data;
      setOrderStatusesCount(data);
    } catch (error) {
      console.error(error);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchOrderStatusesCount();
    }
  }, [token, fetchOrderStatusesCount]);

  return (
    <React.Fragment>
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="card-title">Order Stats</h5>
              </div>
            </div>
            {/* RadialChart */}
            <RadialChart orderStatusesCount={orderStatusesCount} />
            <Row>
              {orderStatusesCount && (
                <>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">Approved</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.approvedOrders || 0} orders</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">Dispatched</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.dispatchedOrders || 0} orders</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">In Transit</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.inTransitOrders || 0} orders</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">Delivered</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.deliveredOrders || 0} orders</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">Pending</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.pendingOrders || 0} orders</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="social-source text-center mt-3">
                      <h5 className="font-size-15">Rejected</h5>
                      <p className="text-muted mb-0">{orderStatusesCount.rejectedOrders || 0} orders</p>
                    </div>
                  </div>
                </>
              )}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default SocialSource;
